import {Deserializable} from './deserializable.model';

export class MyobServicePaymentWorkOrder implements Deserializable {
// Myob Service Invoice Payment Model

public UID?: string;
public DepositTo?: string;
public Account?: Account;
// public Customer?: Customer;
Supplier?: Supplier;
// public ReceiptNumber?: string;
PayeeAddress?: string;
StatementParticulars?: string;
PaymentNumber?: string;
Date?: Date;
AmountPaid?: number;
Memo?: string;
Lines?: Line[];
DeliveryStatus?: string;
ForeignCurrency?: any;
RowVersion?: string;



  deserialize(input: any): this {
    // Assign input to our object BEFORE deserialize our cars to prevent already deserialized cars from being overwritten.
    Object.assign(this, input);

    // Iterate over all cars for our user and map them to a proper `Car` model
    //  this.cars = input.cars.map(car => new Car().deserialize(car));

       // Iterate over all addresses for our myob_conntact and map them to a proper `Address` model
    // this.Addresses = input.Addresses.map(address => new Address().deserialize(address));

    return this;
  }
  
//   getFullName() {
//     return this.FirstName + ' ' + this.LastName;
//   }



}
export interface Account {
    UID: string;
    Name: string;
    DisplayID: string;
}

export interface Supplier {
    UID: string;
    Name: string;
    DisplayID: string;
}

export interface Purchase {
    UID: string;
    Number: string;
}

export interface Line {
    RowID: number;
    Type: string;
    Purchase: Purchase;
    AmountApplied: number;
    RowVersion: string;
}




  /*
  * convert the JOSIN results of an API to any Model/Class/Interface Struction
  * @source: http://json2ts.com/
  */  